module.exports = __webpack_public_path__ + "static/live-afbd9aeee937cd03e0c9a5c02099eac3.jpg";